import { Button, Form, Input, Space, Typography, message } from "antd";
import { updateProcurementStageItem } from "apis";
import { useState } from "react";
import { buildStageSK, PROCUREMENT_STAGES } from "types";

const { Text, Link } = Typography;

const SharePointEditor = ({ PK, stageData, setStageData, initialUrl }) => {
  const [url, setUrl] = useState(initialUrl || "");
  const [editMode, setEditMode] = useState(!initialUrl);

  const buildBaseStage = () => ({
    PK: { S: PK },
    SK: { S: buildStageSK(PROCUREMENT_STAGES.Network) },
    stage_name: { S: "Network" },
    entity_type: { S: "ProcurementStage" },
  });

  const handleSaveUrl = async () => {
    try {
      const updatedStage = {
        ...(stageData || buildBaseStage()),
        assessment_folder: url,
      };

      const response = await updateProcurementStageItem(updatedStage);
      if (response.success) {
        message.success("SharePoint URL saved.");
        setEditMode(false);
        setStageData(updatedStage);
      } else {
        message.error("Failed to save URL.");
      }
    } catch (error) {
      message.error("Error saving SharePoint URL.");
    }
  };

  return (
    <>
      <Form layout="inline">
        {editMode ? (
          <>
            <Form.Item label="SharePoint Location for quote">
              <Input
                placeholder="Enter SharePoint URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                style={{ width: 400 }}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSaveUrl}>
                Save
              </Button>
            </Form.Item>
          </>
        ) : (
          <Space>
            <Text strong>Quote File Location:</Text>
            <Link
              href={url}
              target="_blank"
              style={{
                maxWidth: "400px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              {url}
            </Link>
            <Button onClick={() => setEditMode(true)}>Edit</Button>
          </Space>
        )}
      </Form>
      <div style={{ marginTop: "10px" }}>
        <Link
          href="https://collaboration.merck.com/sites/GIODCMOD/ROBO%20Site%20Details/Forms/AllItems.aspx"
          target="_blank"
        >
          Go to Base Folder for getting Link
        </Link>
      </div>
    </>
  );
};

export default SharePointEditor;
